<template>
    <!-- SECTION: Template -->
    <div class="sub-page">
        <!-- ANCHOR: PageTitle -->
        <PageTitle
            :main-title="$t('notice.section1.texts.text1-1')"
            :sub-title="$t('notice.section1.texts.text1-2')"
            bg-color=""
        />

        <!-- ANCHOR: 테이블 -->
        <section class="c-section d-flex justify-center">
            <div class="c-contanier">
                <v-row class="d-flex justify-center">
                    <v-col
                        cols="12"
                        lg="8"
                        md="10"
                        sm="12"
                    >
                        <template v-if="isLoading">
                            <!-- 로딩 -->
                            <div class="d-flex justify-center">
                                <v-progress-circular
                                    indeterminate
                                    color="#FF6442"
                                    size="60"
                                    width="10"
                                ></v-progress-circular>
                            </div>
                        </template>

                        <template v-else-if="getNoticeItems.length === 0">
                            <!-- 게시물 없음 안내 메시지 -->
                            <div class="d-flex justify-center py-10">
                                <div class="text-gray le-text-body1 text-center">
                                    게시된 공지사항이 없습니다.
                                </div>
                            </div>
                        </template>

                        <template v-else>
                            <v-simple-table class="le-simple-table">
                                <template v-slot:default>
                                    <tbody>
                                        <tr
                                            v-for="item in getNoticeItems"
                                            :key="item.id"
                                            @click="goToNotice(item.id)"
                                        >
                                            <td>
                                                <div>
                                                    <div class="d-flex flex-column gap-3">
                                                        <!-- 카테고리 배지 -->
                                                        <div>
                                                            <v-chip
                                                                class="text-white1"
                                                                small
                                                                :color="item.category === 'notice'
                                                                    ? 'blue10'
                                                                    : (item.category === 'event' ? 'orange1' : '')"
                                                            >
                                                                {{ item.category === 'notice'
                                                                    ? '공지사항'
                                                                    : (item.category === 'event' ? '이벤트' : '') }}
                                                            </v-chip>
                                                        </div>

                                                        <!-- 제목 -->
                                                        <div class="le-text-subtitle3 truncate-two-lines">
                                                            {{ item.title }}
                                                        </div>

                                                        <!-- 게시일 -->
                                                        <div class="le-text-body3">
                                                            {{ formatDate(item.publishedDate) }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </template>
                    </v-col>
                </v-row>
            </div>
        </section>
    </div>
    <!-- !SECTION: Template -->
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
// import { getNoticeMetaInfo } from '@/utils/metaInfo.js';
import PageTitle from '@/components/PageTitle.vue';

export default {
    name: 'NoticePage',
    components: {
        PageTitle,
    },

    // metaInfo() {
    //     return getNoticeMetaInfo(this);
    // },

    data() {
        return {
            isLoading: true,
        };
    },

    computed: {
        ...mapGetters('notice', ['getNoticeItems']),
    },

    created() {
        // 기본: 전체(category=all) + 검색어 없음
        this.loadNotices();
    },

    methods: {
        ...mapActions('notice', ['fetchNoticeList']),

        async loadNotices() {
            this.isLoading = true;
            try {
                await this.fetchNoticeList({ category: 'all', query: null });
            } finally {
                this.isLoading = false;
            }
        },

        /* ============================================================
         * ANCHOR: 화면 이동
         * ============================================================ */
        goToNotice(id) {
            this.$router.push({ name: 'NoticeViewPage', query: { id } });
        },

        formatDate(value) {
            if (!value) return '';
            // '2025-11-13T00:00:00' → '2025-11-13'
            return String(value).substring(0, 10);
        },
    },
};
</script>
